import {
  ArticleData,
  ArticleTemplate,
  ID_TO_ARTICLE_TYPE,
  ID_TO_ENTITY_TYPE,
  nameToSlug,
} from 'model/Article';
import { useCallback } from 'react';
import { useSitecoreContext } from './useSitecoreContext';

export const useCalculatedArticleFields = () => {
  const { sitecoreContext: context } = useSitecoreContext();
  const config = context.articleWildcardConfiguration;
  const siteId = context.siteRoot;

  const getUrl = useCallback(
    (name: string, baseUrlFromField?: string) => {
      const baseUrl = baseUrlFromField || config?.baseUrl;
      return baseUrl ? `${baseUrl}/${nameToSlug(name)}` : '';
    },
    [config?.baseUrl]
  );
  const getEntityType = useCallback((template: ArticleTemplate) => {
    const templateIds = [template.id, ...template.baseTemplates.map((t) => t.id)];
    const templateId = templateIds.find((id) => ID_TO_ENTITY_TYPE[id]);
    return templateId ? ID_TO_ENTITY_TYPE[templateId] : undefined;
  }, []);

  const getArticleType = useCallback((template: ArticleTemplate) => {
    const templateIds = [template.id, ...template.baseTemplates.map((t) => t.id)];
    const templateId = templateIds.find((id) => ID_TO_ARTICLE_TYPE[id]);
    return templateId ? ID_TO_ARTICLE_TYPE[templateId] : 'article';
  }, []);

  const getLimitedCapabilities = useCallback(
    (article: Pick<ArticleData, 'limitedDisplay' | 'articleCapabilities'>) => {
      if (article.limitedDisplay.targetId) return article.limitedDisplay.targetId ?? undefined;
      const capability = article.articleCapabilities?.targetItems.find(
        (cap) => !!cap.limitedDisplay && !cap.limitedDisplayExceptions.targetIds.includes(siteId)
      );
      return capability?.limitedDisplay.targetId ?? undefined;
    },
    [siteId]
  );
  return { getUrl, getEntityType, getArticleType, getLimitedCapabilities };
};
